module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("e7Mcb"))).then(() => module.bundle.root('6TueN'));